import api from "./api.ts";

// Access the base URL from environment variables
const url = process.env.REACT_APP_DB_URI;

/**
 * Interface for Search Query Parameters
 */
export interface SearchParams {
    q?: string;
    page?: number;
    page_size?: number;
    type?: string; // Comma-separated list of types: "brand,campaign"
    start_date?: string; // Format: YYYY-MM-DD
    end_date?: string; // Format: YYYY-MM-DD
}

/**
 * Discriminated Union for Metadata based on Result Type
 */
export type SearchResultType =
    | 'contact'
    | 'userquery'
    | 'userprofile'
    | 'organizationprofile'
    | 'campaign'
    | 'brand';

export interface BaseMetadata {
    model: string;
    created_at?: string | null;
}

export interface UserProfileMetadata extends BaseMetadata {
    model: 'user_profile';
    email: string;
    role: string;
    is_verified: boolean;
}

export interface OrganizationProfileMetadata extends BaseMetadata {
    model: 'organization_profile';
    email: string;
    city: string;
    state: string;
    is_verified: boolean;
}

export interface CampaignMetadata extends BaseMetadata {
    model: 'campaign';
    type: string;
    brand: string;
    budget: string;
    deadline: string;
    is_live: boolean;
}

export interface BrandMetadata extends BaseMetadata {
    model: 'brand';
    location: string;
    state: string;
}

export interface ContactMetadata extends BaseMetadata {
    model: 'contact';
    email: string;
    phone: string;
    message: string;
}

export interface UserQueryMetadata extends BaseMetadata {
    model: 'query';
    status: string;
    // updated_at: string;
    // created_at: string;
}

export interface AddMetadata {
    [key: string]: any;
}

/**
 * Interface for a Single Search Result Item
 */
export interface SearchResultItem {
    id: string | number;
    title: string;
    body: string;
    type: SearchResultType;
    metadata: UserProfileMetadata | OrganizationProfileMetadata | CampaignMetadata | BrandMetadata | ContactMetadata | UserQueryMetadata | AddMetadata;
    rank: number;
    created_at: string;
}

/**
 * Interface for the Paginated Search Response
 */
export interface SearchResponse {
    count: number;
    next: string | null;
    previous: string | null;
    results: SearchResultItem[];
}

/**
 * Global Search Function
 * 
 * @param token - The Bearer token for authentication
 * @param params - The search parameters (q, page, type, etc.)
 * @returns Promise resolving to the SearchResponse or an error
 */
export const searchGlobal = async (token: string, params: SearchParams) => {
    try {
        const response = await api.get(`${url}/search/`, {
            params: params
        });
        return response;
    } catch (err) {
        console.error("Search API Error:", err);
        return err;
    }
};
